import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'prettyDuration'
})
export class PrettyDurationPipe implements PipeTransform {

    transform(value: any): any {
        // assumes hours passed in
        let num = parseFloat(value);
        if (isNaN(num)) {
            return '';
        }

        num = (num % .25) != 0 ? num + (.25 - (num % .25)) : num; // round up to the next quarter hour

        let hours = num.toString();
        let minutes = ((num * 60) % 60).toString();
        let length = hours.indexOf(".") != -1 ? hours.indexOf(".") : hours.length;
        let prettyDuration = +hours >= 1 ? hours.substring(0, length) + " hour" : "";
        prettyDuration += +hours >= 2 ? "s" : "";
        length = minutes.indexOf(".") != -1 ? minutes.indexOf(".") : minutes.length;
        prettyDuration += +minutes > 0 ? " " + minutes.substring(0, length) + " minute" : "";
        prettyDuration += +minutes >= 2 ? "s" : "";
        return prettyDuration;
    } // transform()

} // PrettyDurationPipe
